/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Validation_Motivation_Too_LongInputs */

const en_validation_motivation_too_long = /** @type {(inputs: Validation_Motivation_Too_LongInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`At most 2000 characters.`)
};

const de_validation_motivation_too_long = /** @type {(inputs: Validation_Motivation_Too_LongInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Höchstens 2000 Zeichen.`)
};

/**
* | output |
* | --- |
* | "At most 2000 characters." |
*
* @param {Validation_Motivation_Too_LongInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const validation_motivation_too_long = /** @type {((inputs?: Validation_Motivation_Too_LongInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Validation_Motivation_Too_LongInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_validation_motivation_too_long(inputs)
	return en_validation_motivation_too_long(inputs)
});